import Vue from 'vue';

import router from './routing';

import './styles/index.scss';

// Add fastclick for mobile devices
require('fastclick/lib/fastclick');

const VueResource = require('vue-resource');

Vue.use(VueResource);

const app = new Vue({ // eslint-disable-line
  router,
}).$mount('#app');

window.router = router;



// WEBPACK FOOTER //
// ./src/main.js